import { GroupAssessment } from '$synapse/models';

export class GroupAssessmentDTO {
  id: string;
  assessmentName: string;
  description: string;
  groupId: string;
  assessmentId: string;
  advancement: string;
  assessmentIsCertifying: boolean;
  expirationDate: string;

  constructor(groupAssessment: Partial<GroupAssessmentDTO>) {
    this.id = groupAssessment.id;
    this.assessmentName = groupAssessment.assessmentName ?? '';
    this.description = groupAssessment.description ?? '';
    this.groupId = groupAssessment.groupId;
    this.assessmentId = groupAssessment.assessmentId;
    this.advancement = groupAssessment.advancement;
    this.assessmentIsCertifying = groupAssessment.assessmentIsCertifying;
    this.expirationDate = groupAssessment.expirationDate;
  }
}

export function mapToGroupAssessment(dto: GroupAssessmentDTO): GroupAssessment {
  return new GroupAssessment(dto);
}

export class AssociateAssessmentToGroupDTO {
  assessmentIds: string[];
  description: string;
  expirationDate?: string;
}
